module.exports = __webpack_public_path__ + "static/odenwald-5c4eda2b2be66d5505c09b34ebb25a07.png";